import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Modal, Spinner } from 'react-bootstrap';

const PdfViewerModal = ({
  show,
  onHide,
  title,
  loading,
  viewerUrl,
  externalUrl,
  viewerType = 'pdf',
  size = 'xl',
  centered = true,
  dialogClassName = 'engineering-pdf-viewer-modal',
}) => {
  const resolvedTitle = title || 'PDF Viewer';
  const openUrl = externalUrl || viewerUrl;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size={size}
      centered={centered}
      dialogClassName={dialogClassName}
    >
      <Modal.Header closeButton>
        <Modal.Title>{resolvedTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ height: '80vh', padding: 0 }}>
        {loading ? (
          <div className="d-flex align-items-center justify-content-center h-100 p-3">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading file...</span>
            </Spinner>
          </div>
        ) : viewerUrl && viewerType === 'image' ? (
          <div className="d-flex align-items-center justify-content-center h-100 p-3 bg-light">
            <img
              alt={resolvedTitle}
              src={viewerUrl}
              style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
            />
          </div>
        ) : viewerUrl ? (
          <iframe
            title={resolvedTitle}
            src={viewerUrl}
            width="100%"
            height="100%"
            style={{ border: 'none' }}
          />
        ) : (
          <div className="d-flex align-items-center justify-content-center h-100 p-3">
            <Alert variant="warning" className="mb-0">
              Unable to load the PDF viewer for this file.
            </Alert>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-secondary"
          onClick={() => window.open(openUrl, '_blank')}
          disabled={!openUrl}
        >
          Open in New Tab
        </Button>
        <Button variant="primary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

PdfViewerModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  title: PropTypes.string,
  loading: PropTypes.bool,
  viewerUrl: PropTypes.string,
  externalUrl: PropTypes.string,
  viewerType: PropTypes.oneOf(['pdf', 'image']),
  size: PropTypes.string,
  centered: PropTypes.bool,
  dialogClassName: PropTypes.string,
};

PdfViewerModal.defaultProps = {
  title: 'PDF Viewer',
  loading: false,
  viewerUrl: '',
  externalUrl: '',
  viewerType: 'pdf',
  size: 'xl',
  centered: true,
  dialogClassName: 'engineering-pdf-viewer-modal',
};

export default PdfViewerModal;
